import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';

@Component({
  selector: 'intelli-edit-menu',
  templateUrl: './intelli-edit-menu.component.html',
  styleUrls: ['./intelli-edit-menu.component.css']
})
export class IntelliEditMenuComponent implements OnInit {

  constructor() { }

  @Output() changeEditState: EventEmitter<void> = new EventEmitter();
  @Output() change: EventEmitter<string> = new EventEmitter();
  @Input() editState: boolean = false;
  
  ngOnInit() {
  }

  public onChangeEditState() {
    this.change.emit("editState");
  }

  public onBackToList() {
   
    this.change.emit("backToList");
  }

  public onBack() {
  
    this.change.emit("back");
  }
}
